"use client"
import { useEffect } from "react";
import { useRouter } from "next/navigation";

import {useAuth} from "@/context/AuthContext"

import { TJLogo } from "@/assets/icons/Header/SvgUtils";

export default function Home() {
  const router = useRouter();
  const { isAuthReady, userAuthenticated, userDetails } = useAuth();

  useEffect(() => {
    if (!isAuthReady) {
      return;
    }

    if (userAuthenticated) {
      if (!userDetails) {
        router.push("/userNotFound");
        return;
      }

      router.push("/home");
    }
  }, [isAuthReady, router, userAuthenticated, userDetails]);

  useEffect(() => {
    if (window!==undefined && process.env.NEXT_PUBLIC === 'local') {
      // Only import in browser
      import('../mocks/browser').then(({ worker }) => {
        worker.start({
          onUnhandledRequest: 'bypass',
        }).then(() => {
          console.log('%cMSW started in development', 'color: green');
        });
        // Optionally expose for dev
        window.msw = { worker };
      });
    }
  }, []);

  return (
    <div className="w-full h-full flex flex-row justify-center align-middle text-center">
      <div className="flex flex-col justify-center">
      <TJLogo></TJLogo>
      <br/>
        Please Wait ...
      </div>
    </div>
  );
}
